import React, { useState } from "react";
import InputComponent from "../input/InputComponent";
import PhoneInputComponent from "../input-phone-component/PhoneInputComponent";
import styles from "../../components/live-support/liveSupportComponent.module.scss";
import SupportServices from "./services/SupportService";
import { setCookie } from "../../api/utils/utils";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

interface Props {
  setLoggedIn: (loggedIn: boolean) => void;
  setIsLiveChat: (isLiveChat: boolean) => void;
  onSuccess?: (chatId?: number | string) => void;
  onBack?: () => void;
}

const LiveChatForm = ({ setLoggedIn, setIsLiveChat, onSuccess, onBack }: Props) => {
  const [formData, setFormData] = useState({
    guest_name: "",
    guest_email: "",
    guest_phone: "",
  });
  const [errors, setErrors] = useState<{ [key: string]: string }>({
    guest_name: "",
    guest_email: "",
    guest_phone: "",
  });
  const [selectedCode, setSelectedCode] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const translations = useSelector(
    (state: RootState) => state.translations?.data
  );

  const handleSubmit = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    setErrors({ guest_name: "", guest_email: "", guest_phone: "" });

    const payload = {
      guest_name: formData.guest_name,
      guest_email: formData.guest_email,
      guest_phone: formData.guest_phone
        ? `${selectedCode}${formData.guest_phone}`
        : "",
    };

    try {
      const res = await SupportServices.registerUserForChat(payload);
      if (res?.data?.chat_id) {
        setCookie("guest-chat-id", res.data.chat_id);
        if (typeof window !== "undefined") {
          sessionStorage.setItem("guest-chat-id", String(res.data.chat_id));
        }
      }
      if (res?.data?.guest_token) {
        setCookie("guest-token-chat", res.data.guest_token);
        if (typeof window !== "undefined") {
          sessionStorage.setItem("guest-token-chat", res.data.guest_token);
        }
      }
      setLoggedIn(false);
      setIsLiveChat(true);
      if (onSuccess) {
        onSuccess(res?.data?.chat_id);
      }
    } catch (err: any) {
      if (err?.response?.data?.errors) {
        setErrors(err.response.data.errors);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({ ...prev, guest_email: e.target.value }));
  };

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({ ...prev, guest_name: e.target.value }));
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev) => ({ ...prev, guest_phone: e.target.value }));
  };

  const handleCodeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedCode(e.target.value);
  };

  return (
    <form
      className={styles.supportForm}
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
    >
      <div className={styles.formIntro}>

        <h4 className={styles.formIntroTitle}>
          {translations?.start_chat || "Söhbətə başlayın"}
        </h4>

      </div>

      <div className={styles.formFields}>
        <InputComponent
          label={translations?.name || "Adınız"}
          type="text"
          name="guest_name"
          value={formData.guest_name}
          onChange={handleNameChange}
          error={errors?.guest_name}
        />
        <InputComponent
          label={translations?.email || "E-poçt"}
          type="text"
          name="guest_email"
          value={formData.guest_email}
          onChange={handleEmailChange}
          error={errors?.guest_email}
        />
        <PhoneInputComponent
          label={translations?.phone_number || "Telefon nömrəsi"}
          id="guest_phone"
          name="guest_phone"
          value={formData.guest_phone}
          onChange={handlePhoneChange}
          selectedCode={selectedCode}
          onCodeChange={handleCodeChange}
          error={errors?.guest_phone}
        />
      </div>

      <div className={styles.formActionButtons}>
        <button
          type="submit"
          className={styles.startChatBtn}
          disabled={isSubmitting}
          aria-label={"Çata başlayın"}
          tabIndex={0}
        >
          {isSubmitting ? (
            <span className={styles.btnLoaderText}>Qoşulur...</span>
          ) : (
            " Çata başlayın"
          )}
        </button>

      </div>
    </form>
  );
};

export default LiveChatForm;
